import "./style.less";
import { useHtml } from "../../../../providers/html";
interface GeneralInformationProps {}

export const GeneralInformation: React.FC<GeneralInformationProps> = () => {
  const { contactGeneral } = useHtml();
  if (!contactGeneral) return null;
  return <section className="general-information" id="kontakt" dangerouslySetInnerHTML={{ __html: contactGeneral }} />;
};
